import { Button } from '@mui/material';
import Dialog from 'components/dialog';
import List from 'components/list/list';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import { useGet } from 'hooks/use-get';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { getFeedStrategy } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/api/get-ofd-settings';
import { OFD2Params } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-2-params.type';

const FeedStrategyDialog: React.FC<{}> = () => {
  const intl = useIntl();
  const params = useParams<OFD2Params>();
  const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings.dailyConsumptionRateTab';

  const { data: feedReserves, isLoading } = useGet(
    ['getFeedStrategy', params.globalSiteId],
    ({ queryKey }) => getFeedStrategy(String(queryKey[1])),
    {
      enabled: true,
    }
  );

  return (
    <>
      <Dialog
        title={intl.formatMessage({ id: `${PAGE_NAME_ID}.feedStrategyList.title` })}
        maxWidth="sm"
        button={
          <Button
            size="medium"
            onClick={() => console.log(feedReserves)}
            title={intl.formatMessage({ id: `${PAGE_NAME_ID}.feedStrategyList.title` })}>
            <FormattedMessage id={`${PAGE_NAME_ID}.feedStrategyList.title`} />
          </Button>
        }>
        <>
          <List
            isLoading={isLoading}
            dark
            noResult={{ show: !feedReserves?.length, text: intl.formatMessage({ id: 'general.noResults' }) }}
            options={[
              {
                id: 'fromWeight',
                label: intl.formatMessage({ id: `${PAGE_NAME_ID}.feedStrategyList.fromWeightLabel` }),
                autoWidth: true,
              },
              { id: 'name', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.feedStrategyList.nameLabel` }), autoWidth: true },
            ]}>
            {feedReserves?.map((product, idx = product.feedStrategyId) => {
              return (
                <ListRow key={idx}>
                  <ListCell>{product.fromWeight}</ListCell>
                  <ListCell>{`${product.itemName} / ${product.itemNumber}`}</ListCell>
                </ListRow>
              );
            })}
          </List>
        </>
      </Dialog>
    </>
  );
};

export default FeedStrategyDialog;
